import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Checkbox, Tooltip } from "rhombus-react";

import { noop } from "utils/common";
import EmptySection from "widgets/EmptySection";

import { TARGET_METHODS } from "utils/constants";

import ModernSelection from "./ModernSelection";

import "./AutoOptimizationPanel.css";

export default function AutoOptimizationPanel(props){
	let {
			isSelected,
			currentValue,
			onChange,
			isModernEnabled,
			onObjective,
			selectedObjective,
		} = props
		, isLegacy = true
		, $optionsList = null
		, $extraList = null
		;

	if(isModernEnabled){
		if(!currentValue){
			isLegacy = false;
		}
		if(currentValue === TARGET_METHODS.MODERN || currentValue === TARGET_METHODS.MODERN_AUDIENCE){
			isLegacy = false;
		}
	}

	function changeType(e){
		onChange(e.currentTarget.value);
	}

	if(!isSelected){
		return <EmptySection className="choose-existing" icon="autoOptimization" header="Auto-Optimization" />;
	}

	if(isModernEnabled){
		let $modernLabel = (
			<React.Fragment>
				Modern
				<Tooltip description="Optimize to campaign spot groups using a multi-touch attribution model."
					direction="top"
					size="large"
				/>
			</React.Fragment>
		);

		$optionsList = [
			<Checkbox
				label={$modernLabel}
				key="modern"
				type="radio"
				className="modern-checkbox"
				value={TARGET_METHODS.MODERN}
				name="modern-legacy"
				aria-label="Modern"
				checked={!isLegacy}
				onChange={changeType}
			/>
			, <Checkbox
				label="Legacy"
				key="legacy"
				type="radio"
				className="legacy-checkbox"
				value={"legacy"}
				name="modern-legacy"
				checked={isLegacy}
				onChange={changeType}
			/>
		];
	}

	useEffect(() => {
		if(isLegacy) {
			onObjective();
		}
	}, [isLegacy]);

	if(!isModernEnabled || isLegacy){
		$extraList = <LegacySelection isSelected={isSelected} currentValue={currentValue} onChange={onChange} />;
	}
	if(isModernEnabled && !isLegacy){
		$extraList = (
			<ModernSelection
				isSelected={isSelected}
				currentValue={currentValue}
				onChange={onChange}
				onObjective={onObjective}
				selectedObjective={selectedObjective}
			/>
		);
	}

	return (
		<div className="multi-type">
			<h2>Auto-Optimization</h2>
			<aside className="modern-selection">
				{$optionsList}
			</aside>
			{$extraList}
		</div>
	);
}

export function LegacySelection({ isSelected, currentValue, onChange }){
	function handleChange(e){
		onChange(e.target.value);
	}

	function checkboxProps(inputValue){
		return {
			type: "radio",
			onChange: handleChange,
			value: inputValue,
			checked: (inputValue === currentValue),
		};
	}

	return (
		<div className="radio-options">
			<Checkbox
				label = "Click Through Rate"
				key="click-through"
				{...checkboxProps(TARGET_METHODS.CLICK_THROUGH)}
			/>
			<Checkbox
				label = "Acquisition Rate"
				key="acquisition"
				{...checkboxProps(TARGET_METHODS.ACQUISITION_RATE)}
			/>
			<Checkbox
				label = "Interaction Rate"
				key="interaction"
				{...checkboxProps(TARGET_METHODS.INTERACTION_RATE)}
			/>
			<Checkbox
				label = "Percentage Video Played"
				key="percentage-played"
				{...checkboxProps(TARGET_METHODS.PERCENTAGE_VIDEO_PLAYED)}
			/>
			<Checkbox
				label = "Sound On Rate"
				key="sound-on"
				{...checkboxProps(TARGET_METHODS.SOUND_ON_RATE)}
			/>
		</div>
	);
}


AutoOptimizationPanel.displayName = "AutoOptimizationPanel";
AutoOptimizationPanel.propTypes = {
	isSelected: PropTypes.bool,
	currentValue: PropTypes.string,
	onChange: PropTypes.func,
	isModernEnabled:PropTypes.bool,
};

AutoOptimizationPanel.defaultProps = {
	isSelected: false,
	currentValue: null,
	onChange: noop,
	isModernEnabled:false,
};
